<template>
  <div class="bg-white text-align-center">
    <p>
      <span class="card-text-md cl-gray-72">
        Acrescente módulos em {{ message }} usando o menu da esquerda
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'AddComponent',
  components: {},
  computed: {
    message() {
      return this.$store.state.activePageId ? 'sua página' : 'seu pop-up';
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  padding: 85px;
  border: 1px dashed #c2c2c2;

  p {
    display: inline-block;
    width: 264px;
  }

  br + span {
    margin-top: 30px;
    display: inline-block;
  }
}
</style>
